import { h, Component } from 'preact';
import { Row, Column } from '@cube/layout';
import { RenderOnVisible, Truncate } from '@cube/blocks';
import cx from 'classnames';
import dlv from 'dlv';
import style from './style';
import { configure } from '../../../config';
import { getImage, loadBgImage } from '../../../lib/utils';
import { trackingProvider, DIMENSION } from '@cube/track';

// Must have asset with an image and a link
export const canRender = (slide) =>
	dlv(slide, 'assets.0.images', []).length > 0 && dlv(slide, 'assets.0.link.href', '') !== '';

export const getLink = (slide) =>
	dlv(slide, 'assets.0.link.href');

@trackingProvider({
	[DIMENSION.componentpath]: 'PromoOneImage'
})
@configure({
	defaultImageSize: 'dccV2Config.promoOneImage.defaultImageSize'
})
export class Card extends Component {

	onCardClick = (e) => {
		if (this.props.onCardClick) this.props.onCardClick({ pause: false });
	};

	getLinkoutParams(settings) {
		if (dlv(settings, 'assets.0.link.open_new_window')) {
			return {
				target: '_blank',
				rel: 'noopener noreferrer'
			};
		}
	}

	render({ settings, cardSize, overlayMode, lazy, onImageLoad, ...props }) {
		if (!cardSize) cardSize = props.defaultImageSize;

		let styleProps = {};
		let backgroundImage = getImage(settings, cardSize);
		if (!lazy || this.loadedBG === backgroundImage) {
			// If actually loading for first time and onImageLoad defined, fire it
			if (onImageLoad && !this.loadedBG) {
				loadBgImage(backgroundImage, onImageLoad);
			}

			styleProps.style = `background-image: url('${backgroundImage}')`;
			this.loadedBG = backgroundImage;
		}

		return (
			<div data-tb-region-item class={style.wrapperDiv}>
				<a
					href={getLink(settings)}
					{...this.getLinkoutParams(settings)}
					{...styleProps}
					class={cx(style.cardPromoOneImage, style[overlayMode])}
					onClick={this.onCardClick}
				>
					<Row class={style.row}>
						<Column>
							<div class={style.title}>
								<RenderOnVisible>
									<Truncate method="multipleLines" lines="2">
										{dlv(settings, 'assets.0.title_long')}
									</Truncate>
								</RenderOnVisible>
							</div>
						</Column>
					</Row>
				</a>
			</div>
		);
	}
}

const PromoOneImage = {
	canRender,
	getLink,
	Card
};

export default PromoOneImage;
